


































































import { Vue, Component, Prop } from 'vue-property-decorator'
import InfomationForm from './TaiwanInfomationForm.vue'
import ApplicationForm from './TaiwanApplicationForm.vue'
import EducationForm from './TaiwanEducationForm.vue'
import ReportForm from './TaiwanReportForm.vue'
import AwardForm from './TaiwanAwardForm.vue'
import ActivitiesForm from './TaiwanActivitiesForm.vue'
import FamilyForm from './TaiwanFamilyForm.vue'
import IntroduceForm from './TaiwanIntroduceForm.vue'
import Uploader from './TaiwanUploader.vue'
import DoneNotify from './TaiwanDoneNotify.vue'
import Printer from './TaiwanPrinter.vue'
import type { TaiwanEnroll } from '@/models/enrolls/taiwanEnroll'

@Component({
  components: {
    InfomationForm,
    ApplicationForm,
    EducationForm,
    ReportForm,
    AwardForm,
    ActivitiesForm,
    FamilyForm,
    IntroduceForm,
    Uploader,
    DoneNotify,
    Printer
  }
})
export default class TaiwanBaseEnrollForm extends Vue {
  @Prop({ required: true }) value!: TaiwanEnroll
  @Prop({ default: false }) print!: boolean
  @Prop({ default: '' }) title!: string

  active = 0
  steps = [
    '个人信息',
    '专业志愿',
    '教育背景',
    '考试成绩',
    '获奖情况',
    '其他活动',
    '家庭成员',
    '个人陈述',
    '上传材料',
    '完成'
  ]

  get disabled() {
    return {
      prev: this.active === 0,
      next: this.active === this.steps.length - 1
    }
  }
}
